<template>
  <div class="ldgl-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="关键字">
              <el-input v-model="search" placeholder="关键字搜索" style="width: 230px;" @keyup.enter.native="Search"/>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="addTemplate">添加报价书</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="报价书编码"
                    min-width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: bold">{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="年份"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.year}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="90"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.bid===1">乔金斯</span>
                      <span v-if="scope.row.bid===3">首造</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="上传人"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.username}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="上传时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="280"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button icon="el-icon-download" size="mini" @click="downLoad(scope.row)">下载</el-button>
                      <el-button icon="el-icon-edit" size="mini" @click="editTemplate(scope.row)">修改</el-button>
                      <el-button icon="el-icon-delete" size="mini" @click="deleteTemplate(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="420px">
      <el-form ref="addForm" size="small" label-width="90px" :model="addForm" :rules="addRules">
        <el-form-item label="品牌" prop="bid">
          <el-select v-model="addForm.bid" placeholder="请选择">
            <el-option label="乔金斯" v-if="user.dGroupid===2" :value="1"></el-option>
            <el-option label="首造" v-if="user.dGroupid===1" :value="3"></el-option>
            <el-option label="帆向" v-if="user.dGroupid===35" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报价书年份" prop="year">
          <el-date-picker v-model="addForm.year" type="year" placeholder="请选择" value-format="yyyy"></el-date-picker>
        </el-form-item>
        <el-form-item label="报价书编码" prop="name">
          <el-input v-model="addForm.name" type="text" placeholder="请输入报价书编码" maxlength="100" show-word-limit/>
        </el-form-item>
        <el-form-item label="上传报价书" prop="fileid">
          <SingleFile :key="addForm.key" v-model="addForm.fileid" :accept="'.pdf'" :old="oldFile" :tip="'只能上传pdf'" />
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button :loading="btnLoading" type="primary" @click="submitTemplate">立即提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getQuote, addOrEditQuote, delQuote } from '@/api/erp'
import SingleFile from '../../../components/upload/SingleFile'
import { getFileInfo } from '@/api/pub'

export default {
  name: 'bjs',
  components: {
    SingleFile
  },
  data() {
    return {
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      addForm: {
        qid: 0,
        name: '',
        year: '',
        fileid: '',
        key: new Date().getTime.toString(),
        bid: null
      },
      oldFile: [],
      addRules: {
        name: [{ required: true, message: '请输入报价书编码', trigger: 'blur' }],
        year: [{ required: true, message: '请选择报价书年份', trigger: 'blur' }],
        fileid: [{ required: true, message: '请上传报价书', trigger: 'change' }],
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }]
      },
      dialogTitle: '',
      dialogVisible: false,
      btnLoading: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        name: this.search,
        groupid: this.user.dGroupid
      }
      this.loading = true
      getQuote(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    downLoad(row) {
      getFileInfo({ fileid: row.fileid }).then(response => {
        const a = document.createElement('a')
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                  href: response.data.copyPath,
                  target: '_blank',
                  download: `${response.data.dName}.${response.data.dType}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    addTemplate() {
      this.addForm.qid = 0
      this.addForm.name = ''
      this.addForm.year = ''
      this.addForm.fileid = ''
      this.addForm.bid = null
      this.addForm.key = new Date().getTime().toString()
      this.oldFile = []
      this.dialogTitle = '添加报价书'
      this.dialogVisible = true
    },
    editTemplate(row) {
      this.addForm.qid = row.qid
      this.addForm.name = row.name
      this.addForm.bid = row.bid
      this.addForm.year = row.year
      this.addForm.fileid = row.fileid
      this.oldFile = [{ id: row.fileid, name: row.filename }]
      this.addForm.key = new Date().getTime().toString()
      this.dialogTitle = '修改报价书'
      this.dialogVisible = true
    },
    deleteTemplate(row) {
      this.$confirm('您确定要删除此报价书吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delQuote({ qid: row.qid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    submitTemplate() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          if (!this.btnLoading) {
            this.btnLoading = true
            const data = {
              qid: this.addForm.qid,
              userid: this.user.dUserid,
              fileid: this.addForm.fileid,
              name: this.addForm.name,
              year: this.addForm.year,
              bid: this.addForm.bid
            }
            addOrEditQuote(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    Search() {
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.pageSize = 1
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.ldgl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
